/**
 * The shell's location, offered to the pages' PageHeader (WP-18, ux/01 §6.3):
 * the resolved menu leaf, the menu mode and the two actions a breadcrumb
 * needs. `null` outside the pharmacy shell (fournisseur portal, tests): the
 * PageHeader then shows the breadcrumbs the page passes.
 */
import * as React from "react";
import type { NavActive } from "./useNavModel";

export interface ShellNav {
  pathname: string;
  mode: "tree" | "flat" | "none";
  active: NavActive | null;
  requestFlyout: (categoryId: string) => void;
  setDocumentLabel: (path: string, label: string | null) => void;
}

export const ShellNavContext = React.createContext<ShellNav | null>(null);
